import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';

import { TuiButton, TuiDialogService } from '@taiga-ui/core';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-session-timeout-warning',
  standalone: true,
  imports: [TuiButton],
  templateUrl: './session-timeout-warning.html',
  styleUrl: './session-timeout-warning.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionTimeoutWarningComponent {
  private sessionService = inject(SessionService);
  private dialogService = inject(TuiDialogService);

  isWarningVisible = this.sessionService.isWarningVisible;
  countdown = this.sessionService.countdown;

  formatTimeRemaining(): string {
    const totalSeconds = this.countdown();
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  extendSession(): void {
    this.sessionService.refreshSession().subscribe();
  }

  logout(): void {
    this.sessionService.logout().subscribe();
  }
}
